import { UseFormRegisterReturn } from 'react-hook-form';

import CheckBox from '~components/Checkbox';
import ContentModal from '~components/ContentModal';
import Input from '~components/Input';
import { ModalBaseProps } from '~components/ModalBase';
import Text from '~components/Text';
import Textarea from '~components/Textarea';
import useMedia from '~hooks/useMedia';

import { useFeedbackForm } from './helper/useFeedbackForm';
import { S } from './style';

type Props = Pick<ModalBaseProps, 'isOpen' | 'handleClose'>;

function FeedbackModal({ isOpen, handleClose }: Props) {
  const {
    registers,
    handleSubmit,
    formState: { isDirty, isValid },
    resetForm,
  } = useFeedbackForm();

  return (
    <ContentModal
      isOpen={isOpen}
      handleClose={handleClose}
      title={FeedbackTitle()}
      content={FeedbackContent(registers)}
      handleConfirm={() => {
        handleSubmit();
        handleClose();
      }}
      handleCancel={() => {
        handleClose();
        resetForm();
      }}
      confirmButtonText='제출'
      confirmButtonProps={{ disabled: !isDirty || !isValid }}
    />
  );
}

export default FeedbackModal;

function FeedbackTitle() {
  const { isMobile } = useMedia();

  return (
    <S.TitleWrapper>
      <img src='/images/pencil.png' alt='pencil' />
      <Text typography={isMobile ? 'bold150_H5' : 'bold150_B1'} as='p'>
        피드백 보내기
      </Text>
      <Text typography='midium150_B3'>
        여러분의 소중한 의견으로 <br />
        더욱 발전하는 크레딧잡이 되겠습니다.
      </Text>
    </S.TitleWrapper>
  );
}

function FeedbackContent(registers: {
  email: UseFormRegisterReturn<'email'>;
  feedback: UseFormRegisterReturn<'feedback'>;
  policy: UseFormRegisterReturn<'policy'>;
}) {
  return (
    <S.ContentWrapper>
      <Input
        id='email'
        label='이메일'
        placeholder='example@kreditjob.com'
        register={registers.email}
        fullWidth
      />
      <Textarea
        id='feedback'
        label='의견작성'
        placeholder='의견을 작성해주세요.'
        register={registers.feedback}
        inputCss={S.InputCss}
        fullWidth
      />
      <div>
        <CheckBox
          id='policy'
          label='개인정보 수집 및 이용에 대한 동의'
          register={registers.policy}
        />
        <Text typography='midium150_C1' as='p'>
          ① 수집 항목 : 이메일 ② 목적 : 사용자 문의 응대 ③ 보관기간 : 문의 대응 완료 후 파기 (동의
          거부 시, 문의 접수가 어렵습니다.)
        </Text>
      </div>
    </S.ContentWrapper>
  );
}
